import { useEffect, useState } from "react";
import { Select, Typography } from "antd";

const { Text } = Typography;

const CustomTypableSelect = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  mode,
  size = "middle",
  variant = "outlined",
  allowClear,
  showSearch = true,
  disabled,
  status,
  labelColor = "#000",
  style = { width: "100%" },
  errorMessage,
  className,
  defaultOptions = [],
  showRequired = false,
  showOptional = false,
}) => {
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (defaultOptions?.length > 0) {
      const uniqueOptions = Array.from(
      new Set(defaultOptions.map(opt => opt.trim()))
    );
    setOptions(uniqueOptions);
    }
  }, [defaultOptions]);

  const handleChange = (val) => {
    if (!options.includes(val)) {
      setOptions([...options, val]);
    }
    onChange(val);
  };

  const handleSearch = (val) => {
    setInputValue(val);
  };

  const filteredOptions = options.filter((option) =>
    option?.toLowerCase().includes(inputValue.toLowerCase())
  ); 

  const dropdownOptions = inputValue && !options.includes(inputValue)
    ? [...filteredOptions, inputValue]
    : filteredOptions;

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {label && (
        <div style={{ marginBottom: 8, fontWeight: 400, color: labelColor }}>
          {label}
          {showRequired ? (
            <span style={{ color: "red" }}>*</span>
          ) : showOptional ? (
            <span  style={{ color: "#8C8C8C" }}>{" (Optional)"}</span>
          ) : null}
        </div>
      )}
      <Select
        id={id}
        mode={mode}
        size={size}
        value={value === "" || value === 0 ? undefined : value}
        variant={variant}
        className={className}
        allowClear={allowClear}
        showSearch={showSearch}
        disabled={disabled}
        style={style}
        placeholder={placeholder}
        status={status}
        onChange={handleChange}
        onSearch={handleSearch}
        filterOption={false}  
        options={dropdownOptions.map((opt) => ({
          label: opt,
          value: opt,
        }))}
      />
      {errorMessage && (
        <Text type="danger" style={{ marginTop: 5 }}>
          {errorMessage}
        </Text>
      )}
    </div>
  );
}

export default CustomTypableSelect;